import { View, Text } from "@react-pdf/renderer";

const ListItem = ({
  children,
  id,
  marker,
  markerWidth = 24,
  styles,
  textStyle,
  wrap = true,
}) => (
  <View
    id={id}
    style={[styles.flexRow, styles.alignStart, { columnGap: 12 }]}
    wrap={wrap}
  >
    {marker ? (
      <Text style={[textStyle, { width: markerWidth, flexShrink: 0 }]}>
        {marker}
      </Text>
    ) : null}
    <Text style={[textStyle, styles.grow, { flexShrink: 1 }]}>{children}</Text>
  </View>
);
export default ListItem;
